<template>
  <div>
    <div class="menu">
      <div class="blockOuter halfBlock firstM">
        <div class="blockInner">
          <div class="title">
            <div class="titleInner" @mouseenter="showlines" @mouseleave="showlines" @touchstart="touchlines" @touchend="touchlines">
              <template v-if="$route.name === 'info'">
                <span class="highlight">Infos &</span><br>
                <span class="highlight">Contact</span>
              </template>

              <template v-else>
                <span class="highlight" v-html="project.title"></span>
                <span v-if="project.subtitle" class="highlight" v-html="'<br>' + project.subtitle"></span>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="blockOuter halfBlock middleM">
        <div class="blockInner"></div>
      </div>

      <div class="blockOuter halfBlock lastM">
        <div class="blockInner">
          <div class="title">
            <div class="titleInner">
              <div class="close">
                <div class="moreLines">
                  <div class="moreV highlight"></div>
                  <div class="moreH highlight"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="menu" id="menu2" :class="{showLines: $store.state.lines}">
      <div class="blockOuter halfBlock firstM">
        <div class="blockInner">
          <div class="title">
            <div class="titleInner" @mouseenter="showlines" @mouseleave="showlines" @touchstart="touchlines" @touchend="touchlines">
              <template v-if="$route.name === 'info'">
                <span>Infos &</span><br>
                <span>Contact</span>
              </template>

              <template v-else>
                <span class="highlight" v-html="project.title"></span>
                <span v-if="project.subtitle" class="highlight" v-html="'<br>' + project.subtitle"></span>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="blockOuter halfBlock middleM">
        <div class="blockInner"></div>
      </div>

      <div class="blockOuter halfBlock lastM">
        <div class="blockInner">
          <div class="title">
            <div class="titleInner">
              <router-link to="/" @mouseenter.native="showlines" @mouseleave.native="showlines" @touchstart.native="touchlines" @touchend.native="touchlines">
                <div class="close"></div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShowLines from '@/components/ShowLines.js'

export default {
  props: ['project'],

  mixins: [ShowLines]
}
</script>
